import { Route, Link } from 'react-router-dom';
import cx from 'classnames';
import styled from 'styled-components';

const TabDiv = styled.div.attrs(({ match }) => ({
  className: cx('tc flex-grow', {
    'bc-link c-link': match,
    'bc-window bg-window-c': !match,
  }),
}))({
  minWidth: 100,
  padding: '14px 10px 7px 10px',
  borderBottomWidth: 2,
  borderBottomStyle: 'solid',
  '& a': {
    display: 'inline-block',
    width: '100%',
    height: '100%',
  },
});

const Tab = ({ title, path }) => (
  <Route path={path} exact>
    {({ match }) => (
      <TabDiv match={match} data-test="tab">
        <Link to={path}>{title}</Link>
      </TabDiv>
    )}
  </Route>
);

export const Tabs = ({ items, className = '' }) => {
  const cls = cx('inline-flex flex-grow items-center justify-stretch', 'window-bg bg-window-c', className);

  return (
    <div className={cls}>
      {items.map((item) => (
        <Tab path={item.path} title={item.title} key={item.path} />
      ))}
    </div>
  );
};

export default Tabs;
